export { AnimatedTouchFeedback } from './AnimatedTouchFeedback';
